import React from 'react';
import { Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import SvgIconNote from '../../images/icons/Note_icon.svg?react';
import { DocumentDispatchContext, DocumentStateContext } from '../../context/DocumentContext';
import { useDocumentAllPages } from '../hooks/useDocumentAllPages';

interface Props {}

const DocumentViewDocumentModal: React.FC<Props> = (props) => {
  const { openViewDocumentModal, viewDocumentPages, viewDocumentId } =
    React.useContext(DocumentStateContext);
  const dispatch = React.useContext<React.Dispatch<any>>(DocumentDispatchContext);

  const documentData = useDocumentAllPages(viewDocumentPages, openViewDocumentModal);

  const isLoading: boolean = documentData.some((result: any) => result.isLoading);
  const isFetching: boolean = documentData.some((result: any) => result.isFetching);
  // const isSuccess: boolean = documentData.every((result: any) => result.isSuccess);

  return (
    <Dialog
      id="create-extraction-batch-dialog"
      data-cy="dialog-view-document"
      fullWidth
      open={openViewDocumentModal}
      PaperProps={{
        style: { border: '1px solid #BDC3D2', maxWidth: '1000px' },
      }}
      onClose={(e, reason) => {
        dispatch({ type: 'TOGGLE_VIEW_DOCUMENT_MODAL' });
      }}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle
        id="form-dialog-title"
        data-cy="form-dialog-title"
        style={{ fontSize: '14px', padding: '10px' }}
      >
        <SvgIconNote style={{ maxHeight: '14px' }} /> View Document {viewDocumentId}
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: '#F5F6Fa' }}>
        <Grid container spacing={6}>
          <Grid container alignItems="center" item xs={12} data-cy="modal-extraction-batch-name">
            {isFetching || isLoading ? <p>Loading...</p> : null}
            {documentData.length > 0
              ? documentData?.map((res: any, index) => {
                  return res.status === 'success' && res.data.file_temp_url ? (
                    <>
                      <div style={{ width: '100%', textAlign: 'right' }}>
                        <Typography
                          style={{
                            fontSize: '12px',
                            textAlign: 'right',
                            marginBottom: '4px',
                            marginTop: '20px',
                          }}
                        >
                          Page {index + 1}
                        </Typography>
                      </div>
                      <img
                        src={res.data.file_temp_url}
                        style={{
                          maxWidth: '100%',
                          border: '1px solid #BDC3D2',
                        }}
                        alt={`Page ${index + 1}`}
                      />
                    </>
                  ) : null;
                })
              : null}

            {viewDocumentPages.length === 0 ? <Typography>No pages found</Typography> : null}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentViewDocumentModal;
